export default {
  slug: "countries",
  endpoint: "countries/",
  titleKey: "countries_title",
  subtitleKey: "countries_sub",
  columns: [{ field: "name", label: "f_name" }],
  fields: [{ name: "name", type: "text", label: "f_name", required: true }],
  injectOnCreate: (item, me) => ({ ...item, company: me && me.company ? me.company.id : null }),
  softDelete: true,
};
